import { useAppAuth } from "@contexts/AuthContext";
import { useParams } from "react-router-dom";
import EditSolicitacao from "./Admin/Edit/Index";
import ResponderSolicitacao from "./User/Responder/Index";
import VisualizarSolicitacao from "./Visitante/Index";
import { perfisAdmin, perfisUnidadeGerencia, perfisVisitante } from "@utils/auth/perfis";

export default function SolicitacaoRoleSwitch() {
  const { id } = useParams();
  const { role } = useAppAuth();

  if (perfisAdmin.includes(role)) return <EditSolicitacao id={id} />;
  if (perfisUnidadeGerencia.includes(role)) return <ResponderSolicitacao id={id} />;
  if (perfisVisitante.includes(role)) return <VisualizarSolicitacao id={id} />;

  // fallback seguro (somente leitura)
  return <VisualizarSolicitacao id={id} />;
}
